import { apiGet, apiPost } from './apiClient';

export interface Project {
  id: string;
  name: string;
  description: string | null;
  created_at: string;
  updated_at: string;
}

export interface Organization {
  id: string;
  name: string;
  slug: string;
  created_at: string;
  logo_url?: string;
  projects: Project[];
  role: string; // роль пользователя в организации
}

export interface UserOrganizationsData {
  organizations: Organization[];
}

export const getUsersOrganizationsAndProjects = async (): Promise<UserOrganizationsData> => {
  try {
    const payload = await apiGet<UserOrganizationsData>('/projects/organizations');
    return payload || { organizations: [] };
  } catch (error) {
    console.error('Error in getUsersOrganizationsAndProjects:', error);
    throw error;
  }
};

export const joinOrganizationByInviteCode = async (
  code: string,
  email: string
): Promise<{ success: boolean; message: string }> => {
  const payload = await apiPost<{ success: boolean; message: string }>('/projects/invites/join', { code, email });
  return payload || { success: false, message: 'Ошибка присоединения' };
};

export const createProject = async (
  organization_id: string,
  name: string,
  description: string,
  type: string
): Promise<{ id: string } | null> => {
  const payload = await apiPost<{ data: { id: string } }>('/projects', {
    organization_id,
    name,
    description,
    type,
  });
  return payload?.data || null;
};

export const getProjectById = async (projectId: string): Promise<{ project: any; files: any[] } | null> => {
  const payload = await apiGet<{ project: any; files: any[] }>(`/projects/${encodeURIComponent(projectId)}`);
  return payload || null;
};